import { AppState } from 'redux/reducers';

export const getLoginPopup = ({ popUp }: AppState) => popUp.loginPopup;
export const getIsShowingCustomLinkPopup = ({ popUp }: AppState) => popUp.isShowingCustomLinkPopup;
